import { render, staticRenderFns } from "./TopNavbarLanguageSwitcher.vue?vue&type=template&id=5352f933&scoped=true&"
import script from "./TopNavbarLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./TopNavbarLanguageSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352f933",
  null
  
)

export default component.exports